export const NAUGHTY_WORDS = new Set([
  'anal',
  'ass',
  'asses',
  'bitch',
  'bitches',
  'blowjob',
  'blunt',
  'boob',
  'boobs',
  'breast',
  'breasts',
  'butt',
  'butts',
  'chink',
  'cocaine',
  'cock',
  'cocks',
  'cum',
  'cunt',
  'cunts',
  'cunty',
  'dick',
  'dicks',
  'dildo',
  'dildos',
  'dildoes',
  'fag',
  'foreplay',
  'fuck',
  'fucks',
  'fucking',
  'gook',
  'hell',
  'horny',
  'jackass',
  'joint',
  'kike',
  'lingerie',
  'mofo',
  'motherfucker',
  'naked',
  'nigga',
  'niggas',
  'nigger',
  'niggers',
  'nude',
  'nude',
  'orgy',
  'penis',
  'pimp',
  'piss',
  'pisses',
  'pissing',
  'porn',
  'prick',
  'pussy',
  'rape',
  'rapes',
  'raped',
  'sex',
  'shit',
  'slut',
  'sluts',
  'slutty',
  'spliff',
  'stripper',
  'strippers',
  'thong',
  'tit',
  'weed',
  'whore',
]);

// This is used for namespacing the undo actions
export const UNDO_NAMESPACE_SYMBOL = Symbol('undo');

// Used by reducers to clean up specific properties that would ordinarily change because of an undo or redo.
export const UndoRedoTreatment = {
  RESPECT: 'RESPECT',
  IGNORE: 'IGNORE',
};
